import { Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { SortDirection, SortParams } from '../typings/grid';
import { State } from '../typings/state';

const PRODUCTS_DEFAULT_SORT_DIRECTION = SortDirection.asc;
const PRODUCTS_DEFAULT_SORT_KEY = 'product-name';

export const selectProductsSortParams = createSelector(
    (state: State) => state.router.query,
    (query?: Query): SortParams | undefined => {
        if (query && query.key) {
            return {
                key: query.key,
                direction: SortDirection[query.direction] || PRODUCTS_DEFAULT_SORT_DIRECTION
            };
        }
        return {
            key: PRODUCTS_DEFAULT_SORT_KEY,
            direction: PRODUCTS_DEFAULT_SORT_DIRECTION
        };
    }
);
